import bugsnag from '@bugsnag/js';
import React from 'react';
import { Provider } from 'react-redux';
import bugsnagReact from '@bugsnag/plugin-react';
import { ThemeProvider } from 'styled-components';
import { ReactQueryDevtools } from 'react-query/devtools';
import { QueryClient, QueryClientProvider, QueryCache } from 'react-query';

// Import store
import store from 'store/store';

// Import global styles
import { pureOttTheme } from 'components/theme/pure_ott_theme/pureOttTheme';
import GlobalStyle from 'components/theme/GlobalStyle';

const bugsnagClient = bugsnag(process.env.REACT_APP_BUGSNAG_CLIENT);
bugsnagClient.use(bugsnagReact, React);

const ErrorBoundary = bugsnagClient.getPlugin('react');

const queryCache = new QueryCache();

const overrides = {
	queryCache,
	defaultOptions: {
		queries: {
			retry: 0,
			refetchOnWindowFocus: false
		}
	}
};

const queryClient = new QueryClient(overrides);

const Providers = ({ children }) => (
	<ThemeProvider theme={pureOttTheme}>
		<GlobalStyle />
		<ErrorBoundary>
			<Provider store={store}>
				<QueryClientProvider client={queryClient}>
					{children}
					<ReactQueryDevtools initialIsOpen={false} />
				</QueryClientProvider>
			</Provider>
		</ErrorBoundary>
	</ThemeProvider>
);

export default Providers;
